
export default function DefaultColumnFilter({ column: { filterValue, setFilter, id}, }) {
    if(['erloes', 'trasse', 'station'].includes(id)) {
        return <></>
    } else {
        return(
            <input value={filterValue || ""}
                onChange={e => {setFilter(e.target.value || undefined)}}
                placeholder={`Suchen...`} className="such-input"/>
        )
    }
}

// INAKTIV SETZEN anstatt LÖSCHEN
// function EintragLöschen ({rowID}) {
//     const {currentTable} = useParams();
//     const history = useLocation();

//     const deleteEntry = event => {
//         event.preventDefault();
//         console.log('>>id', rowID);
//         fetch(server +`/${currentTable}`, {
//             method: "DELETE",
//             cache: "no-cache",
//             headers:{
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(rowID)
//         })
//         .then(answer => {
//             if(answer.ok) {
//                 alert(`Datensatz gelöscht`);
//             } else {
//                 alert("Irgendwas ging schief ):");
//             }
//         })
//         history.goBack();
//     }

//     return (
//         <button className="delete-button" onClick={deleteEntry}>LÖSCHEN</button>
//     )
// }

